// extracted by mini-css-extract-plugin
export default {"quill-modal":"quillModal_quill-modal__EeuhQ","wrapper":"quillModal_wrapper__jRgAN","label":"quillModal_label__msvTn","editor":"quillModal_editor__TUn+P"};